import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  const isHome = location.pathname === "/";

  return (
    <>
      <header
        className={`navWrap ${scrolled ? "navWrap--scrolled" : ""} ${!isHome ? "navDark" : "navHome"
          }`}
      >
        <div className="navInner">
          <NavLink to="/" className="brand" aria-label="Go to home">
            <img src={logo} alt="IBS Logo" className="brandLogo" />
          </NavLink>

          <nav className="navDesktop" aria-label="Primary navigation">
            <NavLink to="/" className="navItem">
              Home
            </NavLink>
            <NavLink to="/about" className="navItem">
              About
            </NavLink>
            <NavLink to="/services" className="navItem">
              Services
            </NavLink>

            {/* ✅ NEW */}
            <NavLink to="/projects" className="navItem">
              Projects
            </NavLink>

            <NavLink to="/contact" className="navItem">
              Contact
            </NavLink>
          </nav>

          <button
            className="burger burger--mobile"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
            aria-expanded={open}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      <div
        className={`overlay ${open ? "open" : ""}`}
        onClick={() => setOpen(false)}
      />

      <aside
        className={`drawer ${open ? "open" : ""}`}
        aria-hidden={!open}
        aria-label="Mobile menu"
      >
        <div className="drawerTop">
          <img src={logo} alt="IBS Logo" className="drawerLogo" />
          <button
            className="closeBtn"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <div className="drawerLinks">
          <NavLink to="/" className="drawerLink">
            Home
          </NavLink>
          <NavLink to="/about" className="drawerLink">
            About
          </NavLink>
          <NavLink to="/services" className="drawerLink">
            Services
          </NavLink>

          {/* ✅ NEW */}
          <NavLink to="/projects" className="drawerLink">
            Projects
          </NavLink>

          <NavLink to="/contact" className="drawerLink">
            Contact
          </NavLink>
        </div>
      </aside>
    </>
  );
}
